import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { addTonnageMasterAsync } from "../../../../redux/features/tonnage-master/addTonnageMasterSlice";
import { useNavigate, useParams } from "react-router-dom";
import { tonnageMasterSingleListAsync } from "../../../../redux/features/tonnage-master/singleListTonnageMasterSlice";
import { useEffect } from "react";
import { updateTonnageMasterAsync } from "../../../../redux/features/tonnage-master/updateTonnageMasterSlice";

const validationSchema = Yup.object().shape({
   tonnage: Yup.string().required("Tonnage value is required"),
});

export default function TonnageMasterAdd() {
   const { id } = useParams();
   const dispatch = useDispatch();
   const navigate = useNavigate();

   const initialValues = {
      tonnage: "",
   };

   const handleTonnageUpdate = async (formData) => {
      formData.id = id;
      dispatch(backdropLoadingAction(true));

      dispatch(
         updateTonnageMasterAsync({
            data: formData,
            done: () => {
               formik.resetForm();
               dispatch(backdropLoadingAction(false));
               toast.success("Tonnage updated successfully.");
               navigate(-1);
            },
            err: () => {
               dispatch(backdropLoadingAction(false));
               //toast.error("Failed to update.");
            },
         }),
      );
   };

   useEffect(() => {
      if (id) {
         dispatch(backdropLoadingAction(true));
         dispatch(
            tonnageMasterSingleListAsync({
               data: { id: id },
               done: (record) => {
                  formik.setFieldValue("tonnage", record?.tonnage);

                  dispatch(backdropLoadingAction(false));
               },
               err: () => {
                  dispatch(backdropLoadingAction(false));
               },
            }),
         );
      }
   }, [id]);

   const formik = useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: handleTonnageUpdate,
   });

   const { getFieldProps, handleSubmit, touched, errors } = formik;

   return (
      <div>
         <BodyHeader title="Tonnage Master" />
         <div className="p-3 shadow-lg">
            <div className="row">
               <div className="col-lg-12">
                  <div className="card card-primary">
                     <div className="card-header">
                        <h3 className="card-title">Tonnage Master Details</h3>
                     </div>

                     <div className="card-body">
                        <div className="row">
                           <div className="col-12 col-sm-12 col-md-6">
                              <CustomInput
                                 require
                                 label="Tonnage"
                                 id="tonnage"
                                 placeholder="Enter volume"
                                 {...getFieldProps("tonnage")}
                                 errors={touched.tonnage && errors.tonnage}
                                 message={errors.tonnage}
                              />
                           </div>
                           <div className="col-lg-12 mt-3 text-center">
                              <button
                                 className="btn btn-primary px-4 py-3"
                                 type="submit"
                                 onClick={handleSubmit}
                              >
                                 <h6 className="mb-0 text-uppercase">Submit</h6>
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
